// inc_newsroom_search.html / inc_newsroom_search_en.html 専用のJS
(function () {
	// 定数定義
	const LATEST_YEAR = document.querySelector('.js-latest-year')?.textContent.trim();
	const EARLIEST_YEAR = document.querySelector('.js-earliest-year')?.textContent.trim();
	const YEAR_COUNT = 21; // 年プルダウンに表示する最大年数（最新年を含む）
	const MAX_KEYWORDS = 5; // キーワードの最大数
	const TIMEZONE_JST = "Asia/Tokyo"; // JSTタイムゾーン
	const ROOT_SELECTOR = ".inc_newsroom_search, .inc_newsroom_search_en"; // 日本語版・英語版の両方に対応
	const SEARCH_PATH_JA = "/newsroom/release/list.html";
	const SEARCH_PATH_EN = "/en/newsroom/release/list.html";

	/**
	 * ルート要素から検索結果ページのパスを取得する
	 * @param {HTMLElement} root - ルート要素
	 * @returns {string} 検索結果ページのパス
	 */
	function getSearchPath(root) {
		return root.classList.contains("inc_newsroom_search_en")
			? SEARCH_PATH_EN
			: SEARCH_PATH_JA;
	}

	/**
	 * 数値を指定桁数でゼロ埋めする
	 * @param {number|string} value - 埋め込み対象の値
	 * @param {number} length - 桁数
	 * @returns {string} ゼロ埋めされた文字列
	 */
	function pad(value, length) {
		return String(value).padStart(length, "0");
	}

	/**
	 * チェックボックスのラベルテキストを取得する
	 * @param {HTMLElement} checkbox - チェックボックス要素
	 * @returns {string} ラベルテキスト
	 */
	function getLabelText(checkbox) {
		const label = checkbox.closest("label");
		if (!label) {
			return "";
		}
		const nameElem = label.querySelector(".rt_cf_nt_name");
		return nameElem ? nameElem.textContent.trim() : label.textContent.trim();
	}

	/**
	 * キーワード入力からキーワード配列を収集する
	 * @param {HTMLElement} root - ルート要素
	 * @returns {string[]} キーワード配列（最大5つ）
	 */
	function collectKeywords(root) {
		const input = root.querySelector(
			'.newsroom-search__keyword-group input[type="text"]',
		);
		if (!input) {
			return [];
		}
		const value = input.value.trim();
		if (!value) {
			return [];
		}
		const keywords = value.split(/\s+/).filter(Boolean);
		return keywords.slice(0, MAX_KEYWORDS);
	}

	/**
	 * 指定名のチェックボックスから選択された値を収集する
	 * @param {HTMLElement} root - ルート要素
	 * @param {string} name - チェックボックス名
	 * @returns {string[]} 選択された値の配列
	 */
	function collectTagParams(root, name) {
		const params = [];
		const checkboxes = Array.from(
			root.querySelectorAll(`input[type=checkbox][name=\"${name}\"]`),
		);
		checkboxes.forEach((checkbox) => {
			if (!checkbox.checked) {
				return;
			}
			const value = checkbox.value.trim() || getLabelText(checkbox);
			if (value) {
				params.push(value);
			}
		});
		return params;
	}

	/**
	 * 期間パラメータを作成する（yyyyMMdd_yyyyMMdd形式）
	 * @param {HTMLElement} root - ルート要素
	 * @returns {string|null} 期間パラメータまたはnull
	 */
	function createPeriodParam(root) {
		const startYear = root.querySelector("#start_year")?.value.trim();
		const startMonth = root.querySelector("#start_month")?.value.trim();
		const endYear = root.querySelector("#end_year")?.value.trim();
		const endMonth = root.querySelector("#end_month")?.value.trim();

		if (!startYear && !endYear) {
			return null;
		}

		const startDate = startYear
			? `${startYear}${startMonth ? pad(startMonth, 2) : "01"}01`
			: "";

		let endDate = "";
		if (endYear) {
			// end_monthの翌月を計算（12月の場合は翌年1月）
			let endMonthNum = endMonth ? Number(endMonth) : 12;
			let endYearNum = Number(endYear);
			endMonthNum += 1;
			if (endMonthNum > 12) {
				endMonthNum = 1;
				endYearNum += 1;
			}
			endDate = `${endYearNum}${pad(endMonthNum, 2)}01`;
		}

		return `${startDate}_${endDate}`;
	}

	/**
	 * URLパラメータからフォームを初期化する
	 * @param {HTMLElement} root - ルート要素
	 */
	function populateFromUrl(root) {
		const params = new URLSearchParams(location.search);
		const keywords = [];
		for (let i = 1; i <= MAX_KEYWORDS; i += 1) {
			const value = params.get(`p_keyword_${i}`)?.trim();
			if (value) {
				keywords.push(value);
			}
		}

		// キーワード設定
		const keywordInput = root.querySelector(
			'.newsroom-search__keyword-group input[type="text"]',
		);
		if (keywordInput && keywords.length) {
			keywordInput.value = keywords.join(" ");
		}

		// チェックボックス設定
		const setCheckboxes = (name, values) => {
			if (!values.length) return;
			const checkboxes = Array.from(
				root.querySelectorAll(`input[type=checkbox][name=\"${name}\"]`),
			);
			checkboxes.forEach((checkbox) => {
				const checkboxValue = checkbox.value.trim();
				const labelValue = checkboxValue || getLabelText(checkbox);
				if (
					values.some(
						(value) => value === checkboxValue || value === labelValue,
					)
				) {
					checkbox.checked = true;
				}
			});
		};

		setCheckboxes(
			"p_category_tags",
			params
				.getAll("p_category_tags")
				.map((v) => v.trim())
				.filter(Boolean),
		);
		setCheckboxes(
			"p_business_tags",
			params
				.getAll("p_business_tags")
				.map((v) => v.trim())
				.filter(Boolean),
		);

		// 期間設定
		const period = params.get("p_period")?.trim();
		if (period) {
			const [start, end] = period.split("_");

			if (start && start.length === 8) {
				const startYear = start.slice(0, 4);
				const startMonth = Number(start.slice(4, 6)); // 文字列から数値に変換

				const startYearSelect = root.querySelector("#start_year");
				const startMonthSelect = root.querySelector("#start_month");
				if (startYearSelect) startYearSelect.value = startYear;
				if (startMonthSelect) startMonthSelect.value = startMonth;
			}

			if (end && end.length === 8) {
				// パラメータは翌月で保存されているため、1つ戻す
				let endMonthNum = Number(end.slice(4, 6)) - 1;
				let endYearNum = Number(end.slice(0, 4));
				if (endMonthNum < 1) {
					endMonthNum = 12;
					endYearNum -= 1;
				}

				const endYearSelect = root.querySelector("#end_year");
				const endMonthSelect = root.querySelector("#end_month");
				if (endYearSelect) endYearSelect.value = String(endYearNum);
				if (endMonthSelect) endMonthSelect.value = endMonthNum;
			}
		}
	}

	/**
	 * 検索URLを構築する
	 * @param {HTMLElement} root - ルート要素
	 * @returns {string} 検索URL
	 */
	function buildSearchUrl(root) {
		const params = new URLSearchParams();

		collectKeywords(root).forEach((keyword, index) => {
			params.append(`p_keyword_${index + 1}`, keyword);
		});

		collectTagParams(root, "p_category_tags").forEach((value) => {
			params.append("p_category_tags", value);
		});

		collectTagParams(root, "p_business_tags").forEach((value) => {
			params.append("p_business_tags", value);
		});

		const periodParam = createPeriodParam(root);
		if (periodParam) {
			params.append("p_period", periodParam);
		}

		const path = getSearchPath(root);
		const queryString = params.toString();
		return queryString ? `${path}?${queryString}` : path;
	}

	/**
	 * 検索ボタンクリック時の処理
	 * @param {Event} event - イベントオブジェクト
	 */
	function handleSearch(event) {
		event?.preventDefault();
		const root =
			event?.currentTarget?.closest(ROOT_SELECTOR) ||
			document.querySelector(ROOT_SELECTOR);
		if (!root) {
			return;
		}
		window.location.href = buildSearchUrl(root);
	}

	/**
	 * select要素にオプションを追加する（datepickerロジックに基づく）
	 * @param {HTMLElement} root - ルート要素
	 */
	function populateSelectOptions(root) {
		const now = new Date();
		const jstNow = new Date(
			now.toLocaleString("en-US", { timeZone: TIMEZONE_JST }),
		);
		const currentYear = jstNow.getFullYear();
		const latestYear = Number(LATEST_YEAR) || currentYear;
		// .js-earliest-year が最新年から20年以内ならそこまで、より古い場合は20年前で打ち切る（最大21年分）
		const minYear = latestYear - (YEAR_COUNT - 1);
		const earliestYear = Math.max(Number(EARLIEST_YEAR) || minYear, minYear);

		// 年selectにオプションを追加
		const yearSelects = root.querySelectorAll("#start_year, #end_year");
		yearSelects.forEach((select) => {
			if (select.options.length > 1) return; // 既に追加済み
			for (let year = latestYear; year >= earliestYear; year--) {
				const option = document.createElement("option");
				option.value = year;
				option.textContent = year;
				select.appendChild(option);
			}
		});

		// 月selectにオプションを追加
		const monthSelects = root.querySelectorAll("#start_month, #end_month");
		monthSelects.forEach((select) => {
			if (select.options.length > 1) return; // 既に追加済み
			for (let month = 1; month <= 12; month++) {
				const option = document.createElement("option");
				option.value = month;
				option.textContent = month;
				select.appendChild(option);
			}
		});
	}

	/**
	 * 年selectの値に応じて対応する月selectの活性/非活性を切り替える
	 * @param {HTMLElement} root - ルート要素
	 */
	function setupYearMonthDependency(root) {
		const pairs = [
			{ yearId: "start_year", monthId: "start_month" },
			{ yearId: "end_year", monthId: "end_month" },
		];

		const syncFns = [];

		pairs.forEach(({ yearId, monthId }) => {
			const yearSelect = root.querySelector(`#${yearId}`);
			const monthSelect = root.querySelector(`#${monthId}`);
			if (!yearSelect || !monthSelect) return;

			const sync = () => {
				const hasYear = Boolean(yearSelect.value);
				monthSelect.disabled = !hasYear;
				if (!hasYear) {
					monthSelect.value = "";
				}
			};

			sync();
			yearSelect.addEventListener("change", sync);
			syncFns.push(sync);
		});

		// クリアボタン押下後は年selectがプログラム的に空にされるため、再同期する
		root.querySelectorAll(".js-newsroom-clear").forEach((btn) => {
			btn.addEventListener("click", () => {
				syncFns.forEach((fn) => fn());
			});
		});
	}

	// 注: 詳細検索トグル(.js-newsroom-toggle)は utils.js が EN/JP ラベル切替も含めて
	// 既にハンドリングしているため、ここで重ねてバインドすると classList.toggle が
	// 二重に呼ばれてキャンセルされ、課題1549 の症状を招く。setupDetailToggle は廃止。

	/**
	 * 初期化処理
	 */
	function init() {
		const root = document.querySelector(ROOT_SELECTOR);
		if (!root) {
			return;
		}

		// 1. selectにoptionを作成する
		populateSelectOptions(root);

		// 2. URLから各parameterを各項目に割り当てる
		setTimeout(() => {
			populateFromUrl(root);
			setupYearMonthDependency(root);
		}, 1);

		// 3. search_btnのクリックイベントをaddEventListenerする
		const searchBtns = root.querySelectorAll("#search_btn, #search_btn_sp");
		const keywordInput = root.querySelector(
			'.newsroom-search__keyword-group input[type="text"]',
		);

		searchBtns.forEach((btn) => {
			btn.addEventListener("click", handleSearch);
		});
		if (keywordInput) {
			keywordInput.addEventListener("keydown", (event) => {
				if (event.key === "Enter") {
					handleSearch(event);
				}
			});
		}

		// 4. 詳細検索トグルは utils.js 側で EN/JP ラベル切替込みで一元管理
	}

	// DOMContentLoaded時に初期化
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
